import enCommon from './locales/en/common.json' with { type: 'json' };
import enAuth from './locales/en/auth.json' with { type: 'json' };
import enTournament from './locales/en/tournament.json' with { type: 'json' };
import enPlayer from './locales/en/player.json' with { type: 'json' };
import enDirector from './locales/en/director.json' with { type: 'json' };
import enNotifications from './locales/en/notifications.json' with { type: 'json' };
import enEmail from './locales/en/email.json' with { type: 'json' };
import enErrors from './locales/en/errors.json' with { type: 'json' };
import enValidation from './locales/en/validation.json' with { type: 'json' };
import plCommon from './locales/pl/common.json' with { type: 'json' };
import plAuth from './locales/pl/auth.json' with { type: 'json' };
import plTournament from './locales/pl/tournament.json' with { type: 'json' };
import plPlayer from './locales/pl/player.json' with { type: 'json' };
import plDirector from './locales/pl/director.json' with { type: 'json' };
import plNotifications from './locales/pl/notifications.json' with { type: 'json' };
import plEmail from './locales/pl/email.json' with { type: 'json' };
import plErrors from './locales/pl/errors.json' with { type: 'json' };
import plValidation from './locales/pl/validation.json' with { type: 'json' };
import deCommon from './locales/de/common.json' with { type: 'json' };
import deAuth from './locales/de/auth.json' with { type: 'json' };
import deTournament from './locales/de/tournament.json' with { type: 'json' };
import dePlayer from './locales/de/player.json' with { type: 'json' };
import deDirector from './locales/de/director.json' with { type: 'json' };
import deNotifications from './locales/de/notifications.json' with { type: 'json' };
import deEmail from './locales/de/email.json' with { type: 'json' };
import deErrors from './locales/de/errors.json' with { type: 'json' };
import deValidation from './locales/de/validation.json' with { type: 'json' };
export const RESOURCES = {
    en: {
        common: enCommon,
        auth: enAuth,
        tournament: enTournament,
        player: enPlayer,
        director: enDirector,
        notifications: enNotifications,
        email: enEmail,
        errors: enErrors,
        validation: enValidation,
    },
    pl: {
        common: plCommon,
        auth: plAuth,
        tournament: plTournament,
        player: plPlayer,
        director: plDirector,
        notifications: plNotifications,
        email: plEmail,
        errors: plErrors,
        validation: plValidation,
    },
    de: {
        common: deCommon,
        auth: deAuth,
        tournament: deTournament,
        player: dePlayer,
        director: deDirector,
        notifications: deNotifications,
        email: deEmail,
        errors: deErrors,
        validation: deValidation,
    },
    // xx-XX is synthesized at runtime from the English structure: every
    // value becomes `[XX] <full.dotted.key>`. Lets e2e tests catch
    // hardcoded English by switching a user to xx-XX and asserting
    // every visible string starts with `[XX]`. Generated rather than
    // hand-maintained so it stays in sync as new keys land in en/.
    'xx-XX': buildXxLocale({
        common: enCommon,
        auth: enAuth,
        tournament: enTournament,
        player: enPlayer,
        director: enDirector,
        notifications: enNotifications,
        email: enEmail,
        errors: enErrors,
        validation: enValidation,
    }),
};
function buildXxLocale(enBundles) {
    const out = {};
    for (const ns of Object.keys(enBundles)) {
        out[ns] = prefixBundle(enBundles[ns], ns);
    }
    return out;
}
function prefixBundle(node, prefix) {
    // Recursively walk a JSON catalog, replacing every leaf string with
    // `[XX] <prefix>.<keypath>`. Interpolation tokens like {tournament
    // Name} are preserved so vars still substitute correctly.
    if (typeof node !== 'object' || node === null) {
        // Defensive: a top-level non-object bundle (shouldn't happen for
        // namespace bundles, but be safe).
        return {};
    }
    const result = {};
    for (const [key, value] of Object.entries(node)) {
        const path = `${prefix}.${key}`;
        if (typeof value === 'string') {
            // Preserve interpolation tokens so callers can still pass vars.
            const tokens = value.match(/\{[^}]+\}/g) ?? [];
            result[key] =
                `[XX] ${path}` + (tokens.length ? ` ${tokens.join(' ')}` : '');
        }
        else if (Array.isArray(value)) {
            result[key] = value;
        }
        else if (typeof value === 'object' && value !== null) {
            result[key] = prefixBundle(value, path);
        }
        else {
            result[key] = value;
        }
    }
    return result;
}
//# sourceMappingURL=resources.js.map